import cn from 'client/utils/cn';

import React, { Component } from 'react';

import { CommonData, LangSwitcherItem, Link } from 'client/bundles/types';
import LangSwitcher from 'client/components/lang-switcher';

import './index.css';

const b = cn('footer');

interface Props {
    common: CommonData;
    legalDocuments: Link;
    langSwitcher: LangSwitcherItem[];
}

class Footer extends Component<Props> {

    render() {
        const currentYear = new Date()
            .getFullYear()
            .toString();

        const { common, legalDocuments, langSwitcher } = this.props;

        return (
            <footer className={b()}>
                <div className={b('inner')}>
                    <div className={b('copyright')}>
                        &copy;&nbsp;1997–{currentYear}&nbsp;&nbsp;
                        <a
                            className={b('link')}
                            href={common.yandexMainPageUrl}
                            rel="noopener noreferrer"
                            target="_blank"
                            >
                            {common.yandexMainPageTitle}
                        </a>
                    </div>

                    <div className={b('container')}>
                        <div className={b('lang-switcher')}>
                            <LangSwitcher langs={langSwitcher} isShow={common.isLangSwitcherShow} />
                        </div>

                        <div className={b('docs')}>
                            <a
                                className={b('link')}
                                href={legalDocuments.url}
                                rel="noopener noreferrer"
                                target={legalDocuments.isTargetBlank ? '_blank' : ''}
                                >
                                {legalDocuments.title}
                            </a>
                        </div>
                    </div>
                </div>
            </footer>
        );
    }

}

export default Footer;
